<template>
  <ModalConfirmAction
    title="Excluir conta bloqueada"
    message="Tem certeza que deseja remover esta conta bloqueada?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="removerContaBloqueada"
  >
    <template #activator="{ on, attrs }">
      <div class="table-action-box table-action-delete" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
        <span class="table-action-label">Excluir</span>
      </div>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  name: "ModalExcluirContaBloqueada",
  components: { ModalConfirmAction },
  props: {
    getContasBloqueadas: Function,
    cod_conta_bloqueada: Number,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async removerContaBloqueada() {
      try {
        this.loading = true;
        const response = await apiClient.delete(`/removerContaBloqueada/${this.cod_conta_bloqueada}`);

        if (response.status === 200) {
          await this.getContasBloqueadas();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || "Erro ao remover conta.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
